const ERROR_SELECTOR = '[data-slot="error"], .is-invalid';
const FIELD_SELECTOR = '.auth-form__field, .ui-field';
const FOCUSABLE_SELECTOR = 'input:not([type="hidden"]):not([type="file"]), select, textarea';

/**
 * Scrolls to the first visible field with a validation error and focuses it.
 * Runs after the next paint so a wizard step that was just revealed is already displayed.
 */
export function scrollToFirstError() {
    requestAnimationFrame(() => {
        setTimeout(() => {
            const error = Array.from(document.querySelectorAll(ERROR_SELECTOR)).find(
                (element) => element.getClientRects().length > 0,
            );

            if (!error) {
                return;
            }

            const field = error.closest(FIELD_SELECTOR) ?? error;

            field.scrollIntoView({ behavior: 'smooth', block: 'center' });
            field.querySelector(FOCUSABLE_SELECTOR)?.focus({ preventScroll: true });
        }, 50);
    });
}

/** Scrolls to the first error whenever a Livewire component dispatches `scroll-to-first-error`. */
export function listenForValidationFailures() {
    window.addEventListener('scroll-to-first-error', scrollToFirstError);
}
